import T from 'prop-types';
import React from 'react';

import { FormattedMessage } from '@skippay/core/i18n/intl';

import ErrorContent from 'sections/ErrorContent';

function RuntimeErrorScreen(props) {
	const { networkError, error } = props;
	const reloadPage = () => window.location.reload();

	if (networkError) {
		return (
			<ErrorContent
				title={
					<FormattedMessage
						id="screens.runtimeErrorScreen.label.title.networkError"
						defaultMessage="Jste bez internetu."
					/>
				}
				subheading={
					<FormattedMessage
						id="screens.runtimeErrorScreen.label.message.networkError"
						defaultMessage="Ujistěte se, že máte připojení a zkuste aktualizovat."
					/>
				}
				onButtonClick={reloadPage}
			/>
		);
	}
	return (
		<ErrorContent
			title={
				<FormattedMessage
					id="screens.runtimeErrorScreen.label.title"
					defaultMessage="Ajaj, něco se nepovedlo"
				/>
			}
			subheading={
				<FormattedMessage
					id="screens.runtimeErrorScreen.label.message"
					defaultMessage="Zkuste to prosím znovu za chvilku."
				/>
			}
			error={error}
			onButtonClick={reloadPage}
		/>
	);
}

RuntimeErrorScreen.propTypes = {
	networkError: T.bool,
	error: T.string,
};

export default RuntimeErrorScreen;
